module.exports = __webpack_public_path__ + "static/013-a3b1e81fc54f94b82d095a40491c0304.jpeg";